import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {environment} from '../../environments/environment';
import {TenantService} from './tenant.service';
import {PricingPlanDetails} from '../models/pricing-plan-details.model';
import { PaymentMethodConfigurationResponse } from '../models/payment-method-configuration.model';


@Injectable({
  providedIn: 'root'
})
export class StripeConnectionService {
  private http = inject(HttpClient);
  private tenant = inject(TenantService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {


  }

  initStripeConnection(authorizationCode: string): Observable<any> {

    const headers = new HttpHeaders().set('Content-Type', "application/json");

    return this.http.post(environment.api.stripeConnectionUrl, {authorizationCode, tenantId: this.tenant.id}, {headers});
  }

  setupDefaultPricingPlans(monthlyPlanDescription:string, yearlyPlanDescription:string,
                           monthlyPlanPrice:number, yearlyPlanPrice: number,
                           lifetimeAccessPrice:number,
                           teamPlanThreshold:number,
                           teamPlanDiscount:number): Observable<PricingPlanDetails> {


    return this.http.post<PricingPlanDetails>(environment.api.stripeInitPricingPlansUrl,
      {
        monthlyPlanDescription,
        yearlyPlanDescription,
        monthlyPlanPrice,
        yearlyPlanPrice,
        lifetimeAccessPrice,
        teamPlanThreshold,
        teamPlanDiscount,
        tenantId: this.tenant?.id,
      });
  }

  /**
   * Method to call the backend endpoint for checking and enabling Stripe Tax.
   * @param testUser - Flag indicating if the operation is for a test user.
   * @param taxBehavior - The tax behavior to be applied (either 'inclusive' or 'exclusive').
   * @returns Observable containing the response from the backend.
   */
  checkAndEnableStripeTax(testUser: boolean, taxBehavior: string): Observable<any> {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const endpointUrl = environment.api.checkEnableStripeTaxUrl;
    return this.http.post(
      endpointUrl,
      { tenantId: this.tenant.id, testUser, taxBehavior },
      { headers }
    );
  }

  /**
   * Fetches payment method configurations from Stripe
   * @param testUser - Flag indicating if the operation is for a test user
   * @returns Observable containing the payment method configurations
   */
  getPaymentMethodConfigurations(testUser: boolean): Observable<PaymentMethodConfigurationResponse> {
    const params = {
      tenantId: this.tenant.id,
      testUser: testUser.toString()
    };

    return this.http.get<PaymentMethodConfigurationResponse>(
      environment.api.getPaymentMethodsConfigUrl,
      { params }
    );
  }
}
